import type { SiteLocale } from 'types/localisation/SiteLocale';

export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_COUNTRY_NAME = 'United States';
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CURRENCY_CODE = 'USD';

export const DEFAULT_LOCALE_INFO: SiteLocale = {
  countryName: DEFAULT_COUNTRY_NAME,
  countryCode: DEFAULT_COUNTRY_CODE,
  currencyCode: DEFAULT_CURRENCY_CODE,
};
